import React from 'react';
import PropTypes from 'prop-types';
import './Hero.styles.less';

const Hero = ({ children }) => (
  <div className="mpr-hero">
    <div className="mpr-hero__content">
      {children}
    </div>
  </div>
);

Hero.propTypes = {
  children: PropTypes.node
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/Hero/Hero.jsx